<template>
  <div class="freebets-round text-black animation-slide">
    <div class="content-box-style gap-3 flex flex-col">
      <Filters
        :options="options"
        :showActionButton="true"
        :search="search"
        :resetFilter="resetFilter"
        :resetPagination="resetPagination"
      />

      <div
        v-if="isLoading"
        class="flex-1 flex items-center justify-center py-20"ò
      >
        <Loader />
      </div>
      <div
        v-else-if="tableData.length === 0"
        class="flex-1 flex flex-col items-center justify-center py-10 text-gray-400"
      >
        <i class="pi pi-search text-4xl mb-3 opacity-80"></i>
        <span class="font-medium text-lg">No rounds found.</span>
        <p class="text-sm">Try adjusting your filters or search criteria.</p>
      </div>
      <div
        v-else
        class="table-container-custom shadow-sm rounded-2xl overflow-hidden border border-1 mb-3"
      >
        <DataTable
          :value="tableData"
          :lazy="true"
          :paginator="true"
          :rows="selectedLimit"
          :totalRecords="totalElements"
          :first="(currentPage - 1) * selectedLimit"
          @page="onPage"
          @sort="onSort"
          @row-click="onRowClick" 
          rowHover 
          :pt="{
            bodyRow: { class: 'cursor-pointer hover:bg-gray-50 transition-colors duration-200' },
            bodyCell: { class: 'cursor-pointer py-3' } 
          }"
          :sortField="sortField"
          :sortOrder="sortOrder === 'desc' ? -1 : 1"
          dataKey="roundId"
          removableSort
          stripedRows
          scrollable
          scrollHeight="flex"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[15, 25, 50, 100]"
        >
          <template #empty>
            <div class="py-12 text-center text-gray-400 font-medium">
              No rounds found.
            </div>
          </template>


          <Column field="roundId" header="Round ID" sortable>
            <template #body="{ data }">
              <span
                class="text-[11px] font-mono bg-gray-50 border border-gray-100 px-2 py-1 rounded text-gray-600"
              >
                {{ data.roundId }}
              </span>
            </template>
          </Column>
          <Column 
            field="user_id"
            header="Player ID"
            sortable
          >
            <template #body="{ data }">
              <span class="text-gray-500">{{
                data.user_id
              }}</span>
            </template>
          </Column>
 
          <Column 
            field="amount"
            header="Amount"
            sortable
          >
            <template #body="{ data }">
              <span class=" text-gray-500"
                >{{ data?.amount ?? "-"}} {{ data?.currency_code ?? '-'}} / {{ data?.amount_converted ?? "-"}} EUR</span
              >
            </template>
          </Column>

          <template >
            <Column field="win" header="Win" sortable>
              <template #body="{ data }">
                <span
                  :class="
                    data.win > 0
                      ? 'text-emerald-600 font-bold'
                      : 'text-gray-400'
                  "
                >
                  {{ data?.win ?? "-"}} {{ data?.currency_code ?? '-'}} / {{ data?.win_converted ?? "-"}} EUR
                </span>
              </template>
            </Column>
          </template>

          <Column field="created_at" header="Created at" sortable>
            <template #body="{ data }">
              <span class="text-gray-500 whitespace-nowrap">
                {{ formatDate(data.created_at) }}
              </span>
            </template>
          </Column>

          
        </DataTable>
      </div>
    </div>
  </div>

  <RoundModal
    v-if="showDetailModal"
    :title="modalTitle"
    :closeModal="closeModal"
    :isVisible="showDetailModal"
    :roundInfo="roundInfo"
    :skinFilt="skin_id"
  />
</template>
<script>
import Loader from "../Loader.vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import RoundModal from "../Modal/RoundModal.vue";
import Filters from "../table/Filters.vue";
import { getFetch } from "@/api/axiosClient.js";
import { mapGetters } from "vuex";

export default {
  name: "FreebetRounds",
  components: { Filters, DataTable, Column, Button, RoundModal, Loader },
  props: {
    freebet_id: { type: String, required: true },
    skinFilt: { type: Number, required: true },
  },
  data() {
    return {
      currentPage: 1,
      selectedLimit: 15,
      totalElements: 0,
      sortField: "created_at",
      sortOrder: "desc",

      isLoading: false,
      tableData: [],

      round_id: "",
      player_id: "",
      type_id: "All",
      bet_id: "",
      skin_id: 0,

      showDetailModal: false,
      modalTitle: "",
      roundInfo: null,

      options: [
        { label: "Round ID", type: "text", property: "round_id" },
        { label: "Player ID", type: "text", property: "player_id" },
        { label: "Bet ID", type: "text", property: "bet_id" },
        {
          label: "Freebet ID",
          type: "text",
          property: "freebet_id",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getTypeID"]),
  
  },
  methods: {
    onPage(event) {
      this.currentPage = event.page + 1;
      this.selectedLimit = event.rows;
      this.search();
    },

    onSort(event) {
      this.sortField = event.sortField;
      this.sortOrder = event.sortOrder === 1 ? "asc" : "desc";
      this.search();
    },
    async resetFilter() {
      this.currentPage = 1;
      this.sortField = "created_at";
      this.sortOrder = "desc";
      this.round_id = "";
      this.player_id = "";
      this.type_id = "All";
      this.bet_id = "";
      await this.search();
    },
    async search() {
      this.isLoading = true;
      try {
        const params = {
          skin_id: this.skin_id,
          page: this.currentPage,
          limit: this.selectedLimit,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
          freebet_id: this.freebet_id,
        };

        if (this.round_id) params.roundId = this.round_id.trim();
        if (this.player_id) params.user_id = this.player_id.trim();
        if (this.bet_id) params.uuid = this.bet_id.trim();
        if (this.type_id !== "All")
          params.type_id = this.getTypeID(this.type_id);

        const data = await getFetch("spins/", params);
        this.tableData = data.data;
        console.log(data);
        this.totalElements = data.totalItems;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "UTC",
        hour12: false,
      };
      return date.toLocaleString("it-IT", options);
    },
    onRowClick(event) {
    this.openRoundDetail(event.data);
    },
    openRoundDetail(bet) {
      
      if (!bet.roundId || !bet.game_id) return;
      const baseUrl = process.env.VUE_APP_HISTORY || "https://stage-casino.theearplatform.com/stagemoregames/historyPage";
      const url = `${baseUrl}/?round_id=${bet.roundId}&game_id=${
        bet.game_id
      }&token=${bet.token || "demo"}&provider_id=207`;
      window.open(url, "_blank");
    },
    closeModal() {
      this.showDetailModal = false;
    },
  },
  mounted() {
    this.skin_id = this.skinFilt;
    this.search();
  },
};
</script>
